export default __webpack_public_path__ + "static/Moderat-Regular-5110359121873bbfd9a3d69d76a925d4.woff";